var _palette$fontFamilies, _palette$shades$, _palette$shades$2, _palette$fontFamilies2, _palette$shades$3, _palette$shades$4;
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useMeterDetailsStyles = makeStyles({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '16px 16px 12px 16px'
  },
  subtitle: {
    marginTop: '2px',
    color: palette.shades[700]
  },
  tableWrapper: {
    overflowX: 'auto',
    '& .MuiDataGrid-root': {
      border: 'none',
      borderRadius: 0,
      fontSize: '13px',
      fontFamily: (_palette$fontFamilies = palette.fontFamilies) === null || _palette$fontFamilies === void 0 ? void 0 : _palette$fontFamilies.poppins
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: (_palette$shades$ = palette.shades[50]) !== null && _palette$shades$ !== void 0 ? _palette$shades$ : palette.shades[100],
      borderBottom: "1px solid ".concat(palette.shades[300]),
      borderTop: "1px solid ".concat(palette.shades[300]),
      minHeight: '60px !important',
      maxHeight: '60px !important'
    },
    '& .MuiDataGrid-columnHeader': {
      padding: '0 8px',
      borderRight: '1px solid #e1e7ed'
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      whiteSpace: 'normal',
      lineHeight: '1.3',
      fontWeight: 600,
      fontSize: '12px',
      overflow: 'visible',
      textOverflow: 'clip'
    },
    '& .MuiDataGrid-cell': {
      borderBottom: '1px solid #e1e7ed',
      borderRight: '1px solid #e1e7ed',
      padding: '0 8px',
      fontSize: '13px',
      fontWeight: '400 !important'
    },
    '& .MuiDataGrid-cell *': {
      fontWeight: '400 !important'
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: (_palette$shades$2 = palette.shades[50]) !== null && _palette$shades$2 !== void 0 ? _palette$shades$2 : '#fafafa'
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowX: 'auto'
    },
    '& .MuiDataGrid-footerContainer': {
      display: 'none'
    }
  },
  ownerAbsorption: {
    padding: '8px 16px',
    borderTop: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[100]
  },
  meterTotals: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    padding: '16px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  ownerAbsorptionText: {
    fontWeight: 600,
    fontSize: '13px',
    color: palette.shades[800]
  },
  emptyState: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '64px 16px'
  },
  emptyStateIcon: {
    width: 180,
    marginBottom: 16
  },
  emptyStateText: {},
  usageWarning: {
    margin: '12px 16px 0 16px'
  },
  // The plain comparison line, which renders below the metered usage warning: the same margin, but not a warning.
  usageNote: {
    margin: '12px 16px 0 16px'
  },
  usageWarningContent: {
    color: palette.warning.dark,
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '20px',
    padding: '6px 10px',
    borderRadius: '2px',
    backgroundColor: palette.warning.light,
    fontFamily: (_palette$fontFamilies2 = palette.fontFamilies) === null || _palette$fontFamilies2 === void 0 ? void 0 : _palette$fontFamilies2.poppins,
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      marginRight: '4px'
    }
  },
  // The two files of a single-reading template: side by side where there is room, one above the other on a phone.
  uploadAreas: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '16px',
    padding: '0 16px 12px 16px',
    '@media (max-width: 767px)': {
      gridTemplateColumns: 'minmax(0, 1fr)'
    }
  },
  uploadArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '12px 16px',
    border: "1px dashed ".concat(palette.shades[300]),
    borderRadius: '4px',
    backgroundColor: (_palette$shades$3 = palette.shades[50]) !== null && _palette$shades$3 !== void 0 ? _palette$shades$3 : palette.shades[100]
  },
  uploadAreaHeader: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px'
  },
  uploadAreaTitle: {
    fontWeight: 600
  },
  uploadAreaHelp: {
    color: palette.shades[700]
  },
  uploadAreaStatus: {
    color: palette.shades[800],
    fontWeight: 600
  },
  uploadMarkRequired: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '18px',
    padding: '0 8px',
    borderRadius: '9px',
    color: palette.warning.dark,
    backgroundColor: palette.warning.light
  },
  uploadMarkOptional: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '18px',
    padding: '0 8px',
    borderRadius: '9px',
    color: palette.shades[700],
    backgroundColor: (_palette$shades$4 = palette.shades[200]) !== null && _palette$shades$4 !== void 0 ? _palette$shades$4 : palette.shades[100]
  },
  // Held start reads and a refused file: the margin of the usage notes, so the screen reads in one column.
  uploadNotice: {
    margin: '12px 16px 0 16px'
  },
  openingNeeded: {
    color: palette.warning.dark,
    fontWeight: 600
  },
  saveButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px',
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  submitterWrapper: {
    minHeight: '540px'
  }
});
export default useMeterDetailsStyles;